import { Ref } from 'react';
import { useTranslation } from 'react-i18next';
import { COLORS } from '@connect-x-app/shared-ui';
import { CONNECTED_TURNAROUND_TEST_IDS } from '@connect-x-app/web-test-ids';
import { Icon } from '@connect-x-app/web-ui';

import './LauncherButton.scss';

type Props = {
  isOpen: boolean;
  onClick: () => void;
  ref?: Ref<HTMLButtonElement>;
};

export const LauncherButton = ({ isOpen, onClick, ref }: Props) => {
  const { t } = useTranslation();

  return (
    <button
      aria-expanded={isOpen}
      aria-label={t('CONNECTED_TURNAROUND.TITLE')}
      className="connected-turnaround-launcher"
      data-test={CONNECTED_TURNAROUND_TEST_IDS.launcher.toggle}
      onClick={onClick}
      ref={ref}
      type="button"
    >
      {isOpen ? (
        <Icon colorName={COLORS.romeo.$05} name="communicationBubbleSparkleTemplateFill" size={2.4} />
      ) : (
        <Icon colorName={COLORS.yuma.$01} name="communicationBubbleSparkleTemplateOutline" size={2.4} />
      )}
    </button>
  );
};
